import { createSlice } from "@reduxjs/toolkit";

const projectDataSlice = createSlice({
  name: "projectData",
  initialState: {},
  reducers: {
    setProjectData: (_state, action) => action.payload,
  },
});

const allSpacesInProjectSlice = createSlice({
  name: "allSpacesInProject",
  initialState: [],
  reducers: {
    setAllSpacesInProjects: (_state, action) => action.payload,
  },
});

const spaceDataSlice = createSlice({
  name: "spaceData",
  initialState: [],
  reducers: {
    setSpaceData: (_state, action) => action.payload,
  },
});

const breadCrumbDataSlice = createSlice({
  name: "breadCrumbData",
  initialState: [],
  reducers: {
    setBreadCrumbData: (_state, action) => action.payload,
  },
});

export const { setProjectData } = projectDataSlice.actions;
export const { setAllSpacesInProjects } = allSpacesInProjectSlice.actions;
export const { setSpaceData } = spaceDataSlice.actions;
export const { setBreadCrumbData } = breadCrumbDataSlice.actions;

export const projectData = projectDataSlice.reducer;
export const allSpacesInProject = allSpacesInProjectSlice.reducer;
export const spaceData = spaceDataSlice.reducer;
export const breadCrumbData = breadCrumbDataSlice.reducer;

export default breadCrumbDataSlice.reducer;
